import { render, staticRenderFns } from "./speaker-thumb.vue?vue&type=template&id=2c5978e0&scoped=true"
import script from "./speaker-thumb.vue?vue&type=script&lang=js"
export * from "./speaker-thumb.vue?vue&type=script&lang=js"
import style0 from "./speaker-thumb.vue?vue&type=style&index=0&id=2c5978e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5978e0",
  null
  
)

export default component.exports